import React from 'react';
import { Routes, Route, Link, useLocation } from 'react-router-dom';
import { Carousel, Button } from 'antd';
import SkillQuiz from '../components/SkillQuiz';
import MainContent from '../components/MainContent/MainContent'; // Updated import path
import JectHubChallenges from '../pages/Challenges/JectHubChallenges';
import ProjectsList from '../pages/Projects/ProjectsList';
import LearningPage from '../pages/Learning/LearningPage';
import AllCoursesPage from '../pages/Courses/AllCoursesPage';
import Mentorship from '../pages/Students/Mentorship';
import CommunityForum from '../pages/Students/CommunityForum';
import Assessments from '../pages/Assessments/Assessments';
import DonatePage from '../pages/Donate/DonatePage';
import AICareers from '../pages/AboutJectHub/AICareers';
import NewsPage from '../pages/AboutJectHub/NewsPage';
import WhyJectHub from '../pages/AboutJectHub/WhyJectHub';
import JectHubTeam from '../pages/AboutJectHub/JectHubTeam';
import AISystemStatus from '../pages/AboutJectHub/AISystemStatus';
import AITrustSafety from '../pages/AboutJectHub/AITrustSafety';
import UntappedTalentMarkets from '../pages/AboutJectHub/UntappedTalentMarkets';
import TEIStudy from '../pages/AboutJectHub/TEIStudy';
import HowJectHubWorks from '../pages/AboutJectHub/HowJectHubWorks';
import ApplicationDevelopment from '../pages/Solutions/ApplicationDevelopment';
import CloudDevOps from '../pages/Solutions/CloudDevOps';
import CloudMigrations from '../pages/Solutions/CloudMigrations';
import CustomSoftwareDevelopment from '../pages/Solutions/CustomSoftwareDevelopment';
import DataEngineeringAnalytics from '../pages/Solutions/DataEngineeringAnalytics';
import DataScienceAI from '../pages/Solutions/DataScienceAI';
import FlexibleEngagementModels from '../pages/Solutions/FlexibleEngagementModels';
import GenAIEngagementModel from '../pages/Solutions/GenAIEngagementModel';
import LegacySystemModernization from '../pages/Solutions/LegacySystemModernization';
import ThreatDetection from '../pages/Solutions/ThreatDetection';
import GetCertified from '../pages/Students/GetCertified';
import RequestAIDemo from '../pages/Students/RequestAIDemo';
import AILearningPlans from '../pages/Students/AILearningPlans';
import AIDevelopers from '../pages/Students/AIDevelopers';
import AfricaScholarships from '../pages/Students/AfricaScholarships';
import InternshipOpportunities from '../pages/Vendors/InternshipOpportunities';
import VendorPartnerships from '../pages/Vendors/VendorPartnerships';
import SellYourThemes from '../pages/Vendors/SellYourThemes';
import SellAIProducts from '../pages/Vendors/SellAIProducts';
import PlatformOverview from '../pages/Platform/PlatformOverview';
import JectHubFAQs from '../pages/Platform/JectHubFAQs';
import Integrations from '../pages/Platform/Integrations';
import QualifiedByJectHub from '../pages/Platform/QualifiedByJectHub';
import Ebooks from '../pages/Platform/Ebooks';
import ResourceCenter from '../pages/Platform/ResourceCenter';
import CaseStudies from '../pages/Platform/CaseStudies';
import HumansOfJectHub from '../pages/Platform/HumansOfJectHub';
import ProfilesInBrilliance from '../pages/Platform/ProfilesInBrilliance';
import OurProcess from '../pages/ForTalents/OurProcess';
import WhyJoinJectHub from '../pages/ForTalents/WhyJoinJectHub';
import Perks from '../pages/ForTalents/Perks';
import Codewars from '../pages/ForTalents/Codewars';
import AIRevolution from '../pages/News/ArtificialIntelligence/AIRevolution';
import ChallengesData from '../data/ChallengesData';
import ProductsData from '../data/ProductsData';
import PostDetail from '../pages/News/PostDetail';

const PublicRoutes = ({ sliderData }) => {
  const location = useLocation();

  const handleQuizComplete = (score, total) => {
    console.log(`Quiz completed! Score: ${score}/${total}`);
  };

  return (
    <>
      {location.pathname === '/' && (
        <>
          <div className="sliders-section">
            <Carousel autoplay className="carousel">
              {sliderData.map((slide, index) => (
                <div key={index} className="carousel-slide">
                  <img src={slide.image} alt={`Slider ${index + 1}`} className="slider-image" />
                  <div className="slider-content">
                    <h2>{slide.title}</h2>
                    <p>{slide.description}</p>
                    <Link to={slide.link}>
                      <Button
                        type="primary"
                        style={{ marginTop: '10px', backgroundColor: '#1890ff', borderColor: '#1890ff' }}
                      >
                        {slide.buttonText}
                      </Button>
                    </Link>
                  </div>
                </div>
              ))}
            </Carousel>
          </div>
          <div style={{ textAlign: 'center', paddingTop: '20px', backgroundColor: 'rgb(233, 237, 245)' }}>
            <h2>Test Your Knowledge with JectHub</h2>
            <p>
              Take our quick quiz to assess your skills in AI, Cybersecurity, and Data Science, and get personalized
              learning recommendations!
            </p>
            <SkillQuiz onComplete={handleQuizComplete} />
          </div>
        </>
      )}

      <Routes>
        <Route path="/" element={<MainContent challengesData={ChallengesData} productsData={ProductsData} />} />
        <Route path="/challenges" element={<JectHubChallenges columnCount={6} challengesData={ChallengesData} />} />
        <Route path="/projects" element={<ProjectsList />} />
        <Route path="/learning" element={<LearningPage />} />
        <Route path="/courses" element={<AllCoursesPage columnCount={6} />} />
        <Route path="/mentorship" element={<Mentorship />} />
        <Route path="/community" element={<CommunityForum />} />
        <Route path="/assessments" element={<Assessments />} />
        <Route path="/newsroom" element={<NewsPage />} />
        <Route path="/careers" element={<AICareers />} />
        <Route path="/why-jecthub" element={<WhyJectHub />} />
        <Route path="/our-ai-team" element={<JectHubTeam />} />
        <Route path="/ai-status" element={<AISystemStatus />} />
        <Route path="/trust-safety" element={<AITrustSafety />} />
        <Route path="/untapped-talent" element={<UntappedTalentMarkets />} />
        <Route path="/tei-study" element={<TEIStudy />} />
        <Route path="/engagement-models" element={<FlexibleEngagementModels />} />
        <Route path="/application-development" element={<ApplicationDevelopment />} />
        <Route path="/data-science-ai" element={<DataScienceAI />} />
        <Route path="/data-engineering-analytics" element={<DataEngineeringAnalytics />} />
        <Route path="/cloud-devops" element={<CloudDevOps />} />
        <Route path="/custom-software" element={<CustomSoftwareDevelopment />} />
        <Route path="/legacy-modernization" element={<LegacySystemModernization />} />
        <Route path="/genai-engagement" element={<GenAIEngagementModel />} />
        <Route path="/cloud-migrations" element={<CloudMigrations />} />
        <Route path="/cyber-threat-detection" element={<ThreatDetection />} />
        <Route path="/humans-of-jecthub" element={<HumansOfJectHub />} />
        <Route path="/profiles-in-brilliance" element={<ProfilesInBrilliance />} />
        <Route path="/why-join-jecthub" element={<WhyJoinJectHub />} />
        <Route path="/certifications" element={<GetCertified />} />
        <Route path="/sell-ai-products" element={<SellAIProducts columnCount={6} productsData={ProductsData} />} />
        <Route path="/ai-demo" element={<RequestAIDemo />} />
        <Route path="/ai-developers" element={<AIDevelopers />} />
        <Route path="/africa-scholarships" element={<AfricaScholarships />} />
        <Route path="/internships" element={<InternshipOpportunities />} />
        <Route path="/vendor-partnerships" element={<VendorPartnerships />} />
        <Route path="/sell-your-themes" element={<SellYourThemes />} />
        <Route path="/faqs" element={<JectHubFAQs />} />
        <Route path="/platform-overview" element={<PlatformOverview />} />
        <Route path="/integrations" element={<Integrations />} />
        <Route path="/qualified-by-jecthub" element={<QualifiedByJectHub />} />
        <Route path="/ebooks" element={<Ebooks />} />
        <Route path="/resource-center" element={<ResourceCenter />} />
        <Route path="/case-studies" element={<CaseStudies />} />
        <Route path="/our-process" element={<OurProcess />} />
        <Route path="/perks" element={<Perks />} />
        <Route path="/codewars" element={<Codewars />} />
        <Route path="/ai-pricing" element={<AILearningPlans />} />
        <Route path="/donate" element={<DonatePage />} />
        <Route path="/how-it-works" element={<HowJectHubWorks />} />
        <Route path="/pages/news/artificial-intelligence/ai-revolution-in-africa" element={<AIRevolution />} />
        <Route path="/pages/news" element={<NewsPage />} />
        <Route path="/pages/news/:category/:slug" element={<PostDetail />} />
      </Routes>
    </>
  );
};

export default PublicRoutes;